export const CREATE_QUOTE_START = "CREATE_QUOTE_START";
export const CREATE_QUOTE_SUCCESS = "CREATE_QUOTE_SUCCESS";
export const CREATE_QUOTE_FAIL = "CREATE_QUOTE_FAIL";

export const GET_QUOTES_START = "GET_QUOTES_START";
export const GET_QUOTES_SUCCESS = "GET_QUOTES_SUCCESS";
export const GET_QUOTES_FAIL = "GET_QUOTES_FAIL";

export const GET_QUOTE_START = "GET_QUOTE_START";
export const GET_QUOTE_SUCCESS = "GET_QUOTE_SUCCESS";
export const GET_QUOTE_FAIL = "GET_QUOTE_FAIL";

export const UPDATE_QUOTE_START = "UPDATE_QUOTE_START";
export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS";
export const UPDATE_QUOTE_FAIL = "UPDATE_QUOTE_FAIL";

export const CHANGE_QUOTE_STATUS_START = "CHANGE_QUOTE_STATUS_START";
export const CHANGE_QUOTE_STATUS_SUCCESS = "CHANGE_QUOTE_STATUS_SUCCESS";
export const CHANGE_QUOTE_STATUS_FAIL = "CHANGE_QUOTE_STATUS_FAIL";

export const GENERATE_QUOTE_PDF_START = "GENERATE_QUOTE_PDF_START";
export const GENERATE_QUOTE_PDF_SUCCESS = "GENERATE_QUOTE_PDF_SUCCESS";
export const GENERATE_QUOTE_PDF_FAIL = "GENERATE_QUOTE_PDF_FAIL";